let call = (xs, fn) => {
  let tmp = [];
  return tmp.concat(xs).map(fn);
};
let events = (action) => (xs, t, fn, opts) => call(xs, (x) => x[`${action}EventListener`](t, fn, opts));
let classes = (action) => (xs, cns) => call(xs, (x) => x.classList[action](...cns.split(" ")));
let on = (xs, t, fn, opts) => {
  events("add")(xs, t, fn, opts);
  return () => events("remove")(xs, t, fn, opts);
};
let once = (xs, t, fn, opts) => {
  let off = on(xs, t, (ev) => {
    off();
    fn(ev);
  }, opts);
};
let add = (xs, cns) => {
  classes("add")(xs, cns);
};
let remove = (xs, cns) => {
  classes("remove")(xs, cns);
};
let toggle = (xs, cn, force) => {
  call(xs, (x) => x.classList.toggle(cn, force));
};
let has = (xs, cn) => {
  return call(xs, (x) => x.classList.contains(cn)).every((v) => v);
};
function attr(x, n, v) {
  if (arguments.length < 3) {
    return x.getAttribute(n);
  } else if (v) {
    x.setAttribute(n, typeof v === "boolean" ? "" : v);
  } else {
    x.removeAttribute(n);
  }
  return v;
}
function prop(x, n, v) {
  if (arguments.length < 3) {
    return x.style.getPropertyValue(n);
  } else {
    x.style.setProperty(n, v);
    return v;
  }
}
let each = (xs, fn) => {
  for (let i = 0, l = xs.length; i < l; i++) {
    fn(xs[i], i);
  }
};
let size = () => {
  return {
    ww: window.innerWidth,
    wh: window.innerHeight,
    dpr: window.devicePixelRatio
  };
};
let index = (el) => {
  var _a, _b;
  return Array.from((_b = (_a = el.parentNode) == null ? void 0 : _a.children) != null ? _b : []).indexOf(el);
};
let rect = (el) => el.getBoundingClientRect();
let qs = (selector, container = document) => container.querySelector(selector);
let qsa = (selector, container = document) => Array.from(container.querySelectorAll(selector));
let noop = () => {
};
let clamp = (value, min = 0, max = 1) => value < min ? min : value > max ? max : value;
let diagonal = (w, h) => Math.sqrt(w * w + h * h);
let distance = (x1, y1, x2, y2) => diagonal(x1 - x2, y1 - y2);
let lerp = (v0, v1, t) => v0 * (1 - t) + v1 * t;
let map = (value, start1, stop1, start2, stop2) => (value - start1) / (stop1 - start1) * (stop2 - start2) + start2;
let norm = (value, min, max) => (value - min) / (max - min);
let round = (v, p = 3) => {
  let f = 10 ** p;
  return Math.round(v * f) / f;
};
let wrap = (n, l) => n < 0 ? l + n % l : n >= l ? n % l : n;
export { add, attr, clamp, diagonal, distance, each, has, index, lerp, map, noop, norm, on, once, prop, qs, qsa, rect, remove, round, size, toggle, wrap };
